import { proxy } from 'valtio';
import { ERROR_MESSAGES } from '@/constants/messages';
import { handleError } from '@/utils/helpers';
import { ApiService } from '@/services/api';

export interface AuthData {
    isSuperAdmin: boolean;
    email: string | null;
    // uid: string | null;
}

export interface AuthStore {
    data: AuthData | null;
    isLoading: boolean;
    runFetch: (email: string | undefined) => Promise<void>;
    reset: () => void;
}

export const AuthStore = proxy<AuthStore>({
    data: null,
    isLoading: false,
    async runFetch(email) {
        if (!email) {
            AuthStore.data = {
                isSuperAdmin: false,
                email: null
            };
            return;
        }
        
        // 检查host是否匹配test.nivowork.*
        const hostname = window.location.hostname;
        const isTestEnvironment = hostname.startsWith('test.nivowork.') || hostname.startsWith('127.0.0.1');
        
        if (!isTestEnvironment) {
            // 非测试环境，直接设置为非超级管理员
            AuthStore.data = {
                isSuperAdmin: false,
                email: email
            };
            return;
        }
        
        // 如果已经在加载中，避免重复请求
        if (AuthStore.isLoading) {
            return;
        }
        
        AuthStore.isLoading = true;

        try {
            const response = await ApiService.checkSuperAdmin(email);
            console.log('权限检查响应:', response.data);

            if (response.data.success) {
                AuthStore.data = {
                    isSuperAdmin: response.data.isSuperAdmin,
                    email: email
                };
            } else {
                AuthStore.data = {
                    isSuperAdmin: false,
                    email: email
                };
                handleError(response.data.message, ERROR_MESSAGES.CHECK_ERROR);
            }
        } catch (error) {
            AuthStore.data = {
                isSuperAdmin: false,
                email: email
            };
            handleError(error);
        } finally {
            AuthStore.isLoading = false;
        }
    },
    reset() {
        AuthStore.data = null;
        AuthStore.isLoading = false;
    }
});